export const SET_CATEGORIES = 'SET_CATEGORIES';
export const COMMON_SET_ORGANIZATIONS = 'COMMON_SET_ORGANIZATIONS';

export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS';
export const SET_MAP_CENTER = 'SET_MAP_CENTER';

export const SAGA_COMMON_LOAD_ORGANIZATIONS = 'SAGA_COMMON_LOAD_ORGANIZATIONS';
export const SAGA_COMMON_LOAD_CATEGORIES = 'SAGA_COMMON_LOAD_CATEGORIES';

export const setCategories = (categories)=>{
    return {
        type: SET_CATEGORIES,
        payload: {
            categories: categories,
        },
    }
}

export const setOrganizations = (organizations) => {
    return {
        type: COMMON_SET_ORGANIZATIONS,
        payload: {
            organizations: organizations,
        },
    }
}

export const setBounds = (bounds) => {
    return {
        type: SET_MAP_BOUNDS,
        payload: {
            bounds,
        },
    }
}

export const setCenter = (center) => {
    return {
        type: SET_MAP_CENTER,
        payload: {
            center,
        }
    }
}


// WEBPACK FOOTER //
// ./src/shared/actions.js